import React from 'react'
import styled, { keyframes } from 'styled-components';
import LogoImage from '../../assets/lacessLogo.png'

const Footer = () => {
  return (
    <OuterContainer>
      <InnerLogoImage src={LogoImage} alt='로고'/>
      <InnerContainer>
        경기도 성남시 분당구 판교로 255번길 9-22 우림 W-City 709호 &nbsp;&nbsp; | &nbsp;&nbsp; Tel : 031-628-8605 &nbsp;&nbsp; | &nbsp;&nbsp; Fax : 031-628-8601 <br/>
        #708, Woorim W-City, 9-22, 255 Pangyo road, Bundang-gu, Sungnam-si, Kyunggi-do, Korea 13486 &nbsp;&nbsp; | &nbsp;&nbsp; Tel : +82-31-628-8605 &nbsp;&nbsp; | &nbsp;&nbsp; Fax : -82-31-628-8601 <br/>
        COPYRIGHT © 2010 LACESS CO., LTD. ALL RIGHTS RESERVED
        <FooterNav>
          <FooterNavItem href="#company">Company</FooterNavItem>
          <FooterNavItem href="#biz-area">Biz Area</FooterNavItem>
          <FooterNavItem href="#vendor-product">Vendor &amp; Product</FooterNavItem>
          <FooterNavItem href="#contact">Contact</FooterNavItem>
        </FooterNav>
      </InnerContainer>
      <InnerContainerMedia> Woorim W-City, 9-22, 255 Pangyo road, Bundang-gu, Sungnam-si, Kyunggi-do, Korea 13486</InnerContainerMedia>
      <InnerContainerMedia> Tel : +82-31-628-8605</InnerContainerMedia>
      <InnerContainerMedia> Fax : -82-31-628-8601</InnerContainerMedia>
      <InnerContainerMedia> COPYRIGHT © 2010 LACESS CO., LTD. ALL RIGHTS RESERVED</InnerContainerMedia>
      <FooterNavMobile>
        <FooterNavItem href="#company">Company</FooterNavItem>
        <FooterNavItem href="#biz-area">Biz Area</FooterNavItem>
        <FooterNavItem href="#vendor-product">Vendor &amp; Product</FooterNavItem>
        <FooterNavItem href="#contact">Contact</FooterNavItem>
      </FooterNavMobile>
      <InnerLogoImageMedia src={LogoImage} alt='로고'/>
    </OuterContainer>
  );
}

const footerGlow = keyframes`
  0% {
    opacity: 0.34;
    transform: translateX(-18%) scaleX(0.9);
  }
  50% {
    opacity: 0.58;
    transform: translateX(8%) scaleX(1.08);
  }
  100% {
    opacity: 0.34;
    transform: translateX(-18%) scaleX(0.9);
  }
`

const OuterContainer = styled.div`
  width: 100%;
  min-height: 186px;
  height: auto;
  padding: 1.6rem 0;
  background: linear-gradient(140deg, #0e1432 0%, #141c43 42%, #1d2752 100%);
  color: #ecf1ff;
  justify-content: center;
  align-items: center;
  display: flex;
  font-weight: 400;
  border-top: 1px solid rgba(181, 196, 255, 0.45);
  box-shadow: 0 -12px 30px rgba(4, 7, 22, 0.55);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, rgba(102, 125, 255, 0), rgba(155, 178, 255, 0.3), rgba(102, 125, 255, 0));
    transform-origin: center;
    mix-blend-mode: screen;
    animation: ${footerGlow} 7s ease-in-out infinite;
    pointer-events: none;
  }

  & > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    padding: 1.2rem 0 1.5rem;
    height: 300px;
  }
  
  @media (max-width: 900px) and (min-width: 451px) {
    gap: 0.1rem;
  }

  @media (max-width: 450px) {
    height: auto;
  }
`;

const InnerContainer = styled.div`
  width: 70%;
  height: 100%;
  align-content: center;
  line-height: 1.6;
  text-shadow: 0 0 10px rgba(176, 196, 255, 0.18);
  font-size: 0.92rem;

  @media (max-width: 900px) {
    display: none;
  }
`;

const InnerLogoImage = styled.img`
  width: 20%;
  min-width: 160px;
  height: auto;
  object-fit: contain;
  border: 0px;
  transform: scale(0.52);
  background: #cfe1ff;
  border-radius: 16px;
  padding: 14px 20px;
  filter: drop-shadow(0 0 10px rgba(166, 186, 255, 0.25));

  @media (max-width: 900px) and (min-width: 451px) {
    display: none;
  }

  @media (max-width: 450px) {
    display: none;
  }
`

const InnerContainerMedia = styled.div`
  display: none;
  width: 70%;
  padding-bottom: 3%;
  font-size: 0.92rem;
  text-shadow: 0 0 10px rgba(176, 196, 255, 0.18);

  @media (min-width: 451px) and (max-width: 900px) {
    display: block;
  }

  @media (max-width: 450px) {
    display: block;
  }
`

const FooterNav = styled.nav`
  margin-top: 0.72rem;
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.52rem;
  width: 100%;
  justify-content: flex-end;
  text-align: right;

  @media (max-width: 900px) {
    display: none;
  }
`

const FooterNavMobile = styled.nav`
  display: none;
  margin-top: 0.6rem;
  width: 70%;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem 0.9rem;

  @media (max-width: 900px) {
    display: grid;
  }
`

const FooterNavItem = styled.a`
  display: inline-flex;
  font-size: 0.82rem;
  color: rgba(233, 241, 255, 0.92);
  text-decoration: none;
  padding: 0.22rem 0.56rem;
  border-radius: 999px;
  border: 1px solid transparent;
  transition: color 0.18s ease, border-color 0.18s ease;

  &:hover {
    color: #fff;
    border-color: rgba(190, 208, 255, 0.42);
  }
`

const InnerLogoImageMedia = styled.img`
  display: none;
  width: 20%;
  height: auto;
  object-fit: contain;
  border: 0px;
  transform: scale(0.8);
  background: #cfe1ff;
  border-radius: 16px;
  padding: 14px 20px;
  filter: drop-shadow(0 0 8px rgba(166, 186, 255, 0.22));

  /* 450px 이상 800px 미만 */
  @media (min-width: 451px) and (max-width: 900px) {
    padding-top: 20px;
    transform: scale(1);
    display: block;
  }
  
  @media (max-width: 450px) {
    padding-top: 20px;
    transform: scale(1.5);
    display: block;
  }
`


export default Footer
